import { LoadState } from "@redotech/react-util/load";
import PackageXIcon from "@redotech/redo-icons/package-x.svg";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const FulfillmentPartiallySelectedSplit = memo(
  function FulfillmentPartiallySelected({
    doPartialSplit,
    partialSplitLoad,
    selectFullGroups,
  }: {
    doPartialSplit: () => void;
    partialSplitLoad: LoadState<void> | undefined;
    selectFullGroups: () => void;
  }) {
    return (
      <Flex
        style={{
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          overflow: "hidden",
        }}
      >
        <Flex align="center" justify="center" p="4xl">
          <Flex
            bgColor="primary"
            borderRadius="lg"
            dir="column"
            gap="2xl"
            p="2xl"
            style={{ opacity: 1 }}
          >
            <Flex dir="row">
              <PackageXIcon />
              <Text fontSize="md" textColor="primary">
                Partial fulfillments selected
              </Text>
            </Flex>
            <Flex dir="column">
              <Text fontSize="sm" textColor="primary">
                To take action on the selected fulfillments, split them using
                the items you have selected.
              </Text>
              <Flex gap="md" justify="flex-end" p="md">
                <RedoButton
                  disabled={partialSplitLoad?.pending}
                  hierarchy="secondary"
                  onClick={() => selectFullGroups()}
                  size="sm"
                  text="Fully select fulfillments"
                  theme="normal"
                />
                <RedoButton
                  hierarchy="primary"
                  onClick={() => doPartialSplit()}
                  pending={partialSplitLoad?.pending}
                  size="sm"
                  text="Split orders"
                  theme="normal"
                />
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    );
  },
);

export const FulfillmentPartiallySelectedDeselect = memo(
  function FulfillmentPartiallySelected({
    selectFullGroups,
  }: {
    selectFullGroups: () => void;
  }) {
    return (
      <Flex
        style={{
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          overflow: "hidden",
        }}
      >
        <Flex align="center" justify="center" p="4xl">
          <Flex
            bgColor="primary"
            borderRadius="lg"
            dir="column"
            gap="2xl"
            p="2xl"
            style={{ opacity: 1 }}
          >
            <Flex dir="row">
              <PackageXIcon />
              <Text fontSize="md" textColor="primary">
                Partial fulfillments selected
              </Text>
            </Flex>
            <Flex dir="column">
              <Text fontSize="sm" textColor="primary">
                Cannot take action on completed fulfillments with partial
                selection.
              </Text>
              <Flex gap="md" justify="flex-end" p="md">
                <RedoButton
                  hierarchy="secondary"
                  onClick={() => selectFullGroups()}
                  size="sm"
                  text="Fully select fulfillments"
                  theme="normal"
                />
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    );
  },
);
